import {
  OUTLET_BY_ID,
  OUTLET_NEW,
  OUTLET_PRICE,
  OUTLETS_SEARCH,
  OUTLETS_URL,
  UPDATE_SELECTED_OUTLET
} from './constants'

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/outlets_controller.rb#L20
 * @param outletId
 * @param query
 * @return {Axios.IPromise<U>}
 */
export function getOutletById (outletId, query) {
  return axios.get(OUTLET_BY_ID(outletId), {params: query, withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    }).catch((error) => {
      let eobj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/outlets_controller.rb#L26
 * @param data
 * @param params
 * @return {Axios.IPromise<U>}
 */
export function postOutlet (data, params) {
  return axios.post(OUTLETS_URL, data, {params, withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    }).catch((error) => {
      let eobj
      if (error.response) {
        const {response: {data}} = error
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/outlets_controller.rb#L68
 * @param outletId
 * @param data
 * @param queryParams
 * @return {Axios.IPromise<U>}
 */
export function putOutletById (outletId, data, queryParams) {
  return axios.put(OUTLET_BY_ID(outletId), data, {params: queryParams, withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    }).catch((error) => {
      if (error.response) {
        let eobj = new Error(error.response.data.errors)
        return Promise.reject(eobj)
      } else {
        return Promise.reject(new Error(error.message))
      }
    })
}

/**
 * TODO add link
 * @param outletId
 * @param data
 * @param queryParams
 * @return {Axios.IPromise<U>}
 */
export function patchOutletById (outletId, data, queryParams) {
  return axios.patch(OUTLET_BY_ID(outletId), data, {params: queryParams, withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    }).catch((error) => {
      let eobj
      if (error.response) {
        const {response: {data}} = error
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/outlets_controller.rb#L8
 * @return {Axios.IPromise<U>}
 */
export function outlets (params) {
  return axios
    .get(OUTLETS_URL, {params, withCredentials: true})
    .then(response => {
      return Promise.resolve(response)
    })
    .catch((error) => {
      let eobj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/outlets_controller.rb#L113
 * @param params
 * @return {Axios.IPromise<U>}
 */
export function search (params) {
  return axios
    .get(OUTLETS_SEARCH, {params, withCredentials: true})
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      let eobj
      if (error.response) {
        let {data: {errors, message}} = error.response
        if (errors) {
          return new Error(errors)
        } else {
          return new Error(message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/outlets_controller.rb#L124-L124
 * @param params
 * @return {Axios.IPromise<U>}
 */
export function getNew (params) {
  return axios.get(OUTLET_NEW, {params, withCredentials: true})
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      let eobj
      if (error.response) {
        let {data: {errors, message}} = error.response
        if (errors) {
          return new Error(errors)
        } else {
          return new Error(message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v2/sessions_controller.rb#L65
 * @param data
 * @return {Axios.IPromise<U>}
 */
export function patchLogin (data, params) {
  return axios
    .patch(UPDATE_SELECTED_OUTLET, data, {params, withCredentials: true})
    .then(response => {
      return Promise.resolve(true)
    })
    .catch(error => {
      if (error.response && error.response.data.error) {
        return Promise.reject(new Error(error.response.data.error))
      } else {
        return Promise.reject(error)
      }
    })
}

export function getOutletPrice () {
  return axios.get(OUTLET_PRICE, {withCredentials: true})
    .then((res) => {
      return Promise.resolve(res)
    })
    .catch(error => {
      if (error.response && error.response.data.error) {
        return Promise.reject(new Error(error.response.data.error))
      } else {
        return Promise.reject(error)
      }
    })
}



// WEBPACK FOOTER //
// ./app/api/outlets/outlets.js